module.exports = __webpack_public_path__ + "img/previous-arrow.7ee80903.svg";